module.exports = __webpack_public_path__ + "img/coloredeer_white - 鍓湰.99388a40.png";